import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import HttpErrorResponse from '../interfaces/common/httpErrorResponse';
import Paging from '../interfaces/common/paging';
import Pagination from '../interfaces/common/pagination';
import { RootState } from '../setup';
import OrderSource from '../interfaces/output/orderSource';

export type OrderSourceState = {
    orderSource: OrderSource;
    isLoading: boolean;
    orderSources: Pagination<OrderSource>;
    error: HttpErrorResponse | undefined;
};

const initialState: OrderSourceState = {
    orderSource: {} as OrderSource,
    orderSources: { content: [] as Array<OrderSource> } as Pagination<OrderSource>,
    isLoading: false,
    error: undefined
};

export const orderSourceSlice = createSlice({
    name: 'orderSource',

    initialState,
    reducers: {
        fetchOrderSources: (state: OrderSourceState, _action: PayloadAction<{paging: Paging}>) => {
            state.isLoading = true;
        },
        fetchOrderSourcesSuccess: (state: OrderSourceState, action: PayloadAction<Pagination<OrderSource>>) => {
            state.isLoading = false;
            state.orderSources = action.payload;
        },
        fetchOrderSourcesError: (state: OrderSourceState, action: PayloadAction<HttpErrorResponse>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        fetchOrderSourceById: (state: OrderSourceState, _action: PayloadAction<string>) => {
            state.isLoading = true;
        },
        fetchOrderSourceByIdSuccess: (state: OrderSourceState, action: PayloadAction<OrderSource>) => {
            state.isLoading = false;
            state.orderSource = action.payload;
        },
        fetchOrderSourceByIdError: (state: OrderSourceState, action: PayloadAction<HttpErrorResponse>) => {
            state.isLoading = false;
            state.error = action.payload;
        }
    }
});

export const { fetchOrderSources, fetchOrderSourcesSuccess, fetchOrderSourcesError, fetchOrderSourceById, fetchOrderSourceByIdSuccess, fetchOrderSourceByIdError } = orderSourceSlice.actions;

export const isLoadingOrderSources = (state: RootState): boolean => state.orderSourceReducer.isLoading;
export const getOrderSources = (state: RootState): Pagination<OrderSource> => state.orderSourceReducer.orderSources;
export const getOrderSource = (state: RootState): OrderSource => state.orderSourceReducer.orderSource;

export default orderSourceSlice.reducer;